import { jsx as _jsx } from "react/jsx-runtime";
import { WalletIcon } from "../../../icons/wallet.js";
import { Button } from "../../button.js";
import { useAuthContext } from "../context.js";
export const ExternalWalletsAuth = () => {
    const { setAuthStep } = useAuthContext();
    return (_jsx(Button, { variant: "social", icon: _jsx(WalletIcon, {}), onClick: () => setAuthStep({ type: "pick_eoa" }), children: "Continue with a wallet" }));
};
//# sourceMappingURL=InjectedProvidersAuth.js.map